import styled from 'styled-components'

interface StepButtonsContainerProps {
  emphasisNext: boolean
}

export const StepButtonsContainer = styled.div<StepButtonsContainerProps>`
  display: flex;
  flex-direction: row;
  gap: ${({ emphasisNext }) => (emphasisNext ? '22px' : '46px')};

  @media only screen and (max-width: 900px) {
    gap: ${({ emphasisNext }) => (emphasisNext ? '22px' : '13px')};
  }
`

interface StepButtonProps {
  emphasis?: boolean
  next?: boolean
}

export const StepButton = styled.button<StepButtonProps>`
  width: ${({ emphasis }) => (emphasis ? '169%' : '100%')};
  background-color: ${props => (props.next ? 'var(--blue10)' : 'white')};

  height: 50px;
  color: ${({ next }) => (next ? 'white' : 'var(--blue10)')};
  border: 1px solid
    ${({ disabled }) => (disabled ? '#bab5cc' : 'var(--blue10)')};
  border-radius: 50px;
  cursor: ${props => (props.disabled ? 'not-allowed' : 'pointer')};

  font-size: 15px;
  font-weight: 600;
  transition: background-color 0.3s ease-in-out;
`
